import { useMutation } from "@tanstack/react-query"
import { carrotClient } from "#/utils/CarrotClient"
import { UserInfo } from "#/lib/carrot-api/types/UserInfo"

export const useUpdatePartnerInfo = () => {
  return useMutation<Response, Error, Partial<UserInfo>, unknown>(
    (userInfo: Partial<UserInfo>): Promise<Response> => carrotClient.updateUser(userInfo)
  )
}
